/** Strongest → weakest, plus unranked (trains with D4). Mirrors backend levelBands.pure.js. */
export const CLASSEMENTS = [
  "A1", "A2", "A3",
  "B1", "B2", "B3",
  "C1", "C2", "C3",
  "D1", "D2", "D3", "D4",
  "UNRANKED",
];

export const BANDS = ["beginner", "intermediate", "advanced", "professional"];

export const SLOT_ROLES = ["regularity", "game_scheme", "personalized"];

export const CB_STATUSES = ["work", "review", "intro", "locked"];

export function classementLabel(classement, t) {
  if (!classement) return "";
  return classement === "UNRANKED" ? t("levelUnranked") : classement;
}

/** e.g. "C2 · Intermediate · Niveau 3" */
export function levelSummaryLabel(level, t) {
  if (!level) return "";
  const parts = [];
  if (level.classement) parts.push(classementLabel(level.classement, t));
  if (level.band) parts.push(t(`levelBand_${level.band}`));
  if (level.drill_niveau) parts.push(t("levelNiveau", { n: level.drill_niveau }));
  return parts.join(" · ");
}

export function blockedReasonLabel(cb, t) {
  if (cb?.reason === "prereq") {
    return t("levelBlockedReason_prereq", {
      prereq: cb.prereq_name || "",
      stars: cb.prereq_stars ?? "",
    });
  }
  if (cb?.reason === "slot_role") return t("levelBlockedReason_slot_role");
  if (cb?.reason === "intro_level") {
    return t("levelBlockedReason_intro_level", { classement: classementLabel(cb.intro_from_classement, t) });
  }
  if (cb?.reason === "intro_used") return t("levelBlockedReason_intro_used");
  return t("levelBlockedReason_locked");
}

function sameRoles(a, b) {
  const x = [...(a || [])].sort().join(",");
  const y = [...(b || [])].sort().join(",");
  return x === y;
}

function bandCbKey(row) {
  return `${row.band_key}|${row.cb_id}`;
}

/** Edited band × CB rows that differ from the defaults (what a club override must store). */
export function clubOverrideRows(defaultRows = [], editedRows = []) {
  const defaults = new Map(defaultRows.map((r) => [bandCbKey(r), r]));
  return editedRows.filter((r) => {
    const d = defaults.get(bandCbKey(r));
    if (!d) return true;
    return (
      d.status !== r.status ||
      Number(d.star_target) !== Number(r.star_target) ||
      Number(d.priority) !== Number(r.priority) ||
      (d.prereq_stars ?? null) !== (r.prereq_stars ?? null) ||
      (d.intro_from_classement || null) !== (r.intro_from_classement || null) ||
      !sameRoles(d.slot_roles, r.slot_roles)
    );
  });
}

/** CB a template slot pins through its first sequence (or item sub-type), if any. */
export function pinnedTemplateCbId(item) {
  return item?.sequences?.[0]?.sub_type_id || item?.sub_type_id || null;
}
